import { Injectable } from '@angular/core';
import { Localized,  VestmentColor } from '../../../objects';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';
import { ApiService } from '../../../services/api.service';
import { LiturgyType } from './liturgy-type.service';
import { ServiceDateType } from './service-date-type.service';
import { ServiceType } from './service-type.service';
import { FeastType } from './feast-type.service'; 
import { ServiceSearchModel } from '../components/service-search/service-search.component'; 

@Injectable()
export class ServiceService {

  constructor(private apiSvc: ApiService) { }

  public loadEntites(model: ServiceSearchModel): Promise<ServiceSummary[]> {

    const p = new Promise<ServiceSummary[]>((resolve, reject) => {

      //var payload = JSON.stringify(model);
      this.apiSvc.post("api/service/",model).subscribe(
        (data: ServiceSummary[]) => {
          //console.log(data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject();
        }
      );

  });

  return p; 

}

public getItem(id: string  ): Promise<Service> {

  const p = new Promise<Service>((resolve, reject) => {

    this.apiSvc.get("api/service/getitem/" + id, null).subscribe(
      (data: Service) => {
        console.log("service/getitem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
        reject();
      }
    );

  });

  return p;
}


public getSummaryForAutoSuggest(name: string): Promise<ServiceSummary> {

  const p = new Promise<ServiceSummary>((resolve, reject) => {

    var model = {
      ServiceName: name
    }

    this.apiSvc.post("api/service/lookupbyname/", model).subscribe(
      (data: ServiceSummary) => {
        console.log("api/service/lookupbyname/", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

  public save(service: Service, isProofed: boolean): Promise<Service> {

    var payload = {
      Service: service,
      IsProofed: isProofed
    };
 
    const p = new Promise<Service>((resolve, reject) => {

      this.apiSvc.post("api/service/save", payload).subscribe(
        (data: Service) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

    });

  return p;
  }

  public delete(id: string): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {

      this.apiSvc.post("api/service/delete/" + id, null).subscribe(
        () => {
            resolve();
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

    });

  return p;
  }
}



export class ServiceSummary {
  Id: string;
  Name: string;
  SubName: string;
  AvailableSearchTerms: string[];
}

export class Service {
  Id: string;
  Localized: Localized[];
  ReligionBranch: ReligionBranch;
  ServiceType: ServiceType;
  LiturgyType: LiturgyType;
  FeastType: FeastType;
  IsTrialUse: boolean;
  IsUniqueServiceForFeastType: boolean;
  DisplayOrder: number;
  UseProperMap: boolean;
  ServiceDateType: ServiceDateType;
  FixedDateMonth: number;
  FixedDateDay: number;
  OtherServiceId: string;
  VestmentColors: VestmentColor[];
  DesignatedApiService: number;
  IsHiddenForMappingsOfSpecialService: boolean;
  ProofedByName: string;
}

